import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/betSlipModal.css';
import {OPEN_BETS, PLACED_BETS, SETTLED_BETS} from '../../../constants/identifiers';
import OpenBets from './openBets';
import PlacedBets from './placedBets';
import SettledBets from './settledBets';
import {getText} from '../../../helpers/localization';
import Counter from '../components/counter';

// actions
import {
    changeBetSlipModalSelectedScreen,
    openCloseBetSlipModal,
    setBetSlipModalContainerHeight
} from '../actions/betSlipActions';
import {updateSportsBookLocalBetsReadStatus} from "../helpers/betHelpers";
import {getItem} from "../../../helpers/localStorageHelpers";
import {UNREAD_BETS} from "../../../constants/localStorage";

import {collapseOpenBetAccordion, collapsePlacedBetAccordion} from './../../../actions/betSlipActions';
import {getGameCategoryNameByChannel} from '../helpers/gameHelpers';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedBetSlipScreen: state.vpp.selectedBetSlipScreen,
        openBetsList: state.vpp.openBetsList,
        placedBets: state.vpp.placedBets,
        settledBets: state.vpp.settledBets,
        isUnreadBetsNotificationToggled: state.vpp.isUnreadBetsNotificationToggled,
        isBetSlipModalOpen: state.vpp.isBetSlipModalOpen,
        betSlipModalContainerHeight : state.betSlipModalContainerHeight,
        systemLanguage: state.vpp.systemLanguage
    };
};

class BetSlipModal extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedBetSlipScreen: storeData.vpp.selectedBetSlipScreen,
            openBetsList: storeData.vpp.openBetsList,
            placedBets: storeData.vpp.placedBets,
            settledBets: storeData.vpp.settledBets,
            isUnreadBetsNotificationToggled: storeData.vpp.isUnreadBetsNotificationToggled,
            isBetSlipModalOpen: storeData.vpp.isBetSlipModalOpen,
            betSlipModalContainerHeight:storeData.vpp.betSlipModalContainerHeight,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();
        let gameCatgories = [...new Set(this.props.store.getState().vpp.games.map(game => game.gameCategory))];
        if (this.state.placedBets.length < storeData.vpp.placedBets.length) {
            gameCatgories.forEach((gameCategory) => {
                let betsOfGivenCategoryPrev = this.state.placedBets.filter((betSelection) => getGameCategoryNameByChannel(this.props.store, betSelection.Bets[0].Channel) === gameCategory);
                let betsOfGivenCategoryCurrent = storeData.vpp.placedBets.filter((betSelection) => getGameCategoryNameByChannel(this.props.store, betSelection.Bets[0].Channel) === gameCategory);
                if (betsOfGivenCategoryCurrent > betsOfGivenCategoryPrev && storeData.vpp.collapsedPlacedBetAccordions.includes(gameCategory)) {
                    this.props.store.dispatch(collapsePlacedBetAccordion(gameCategory))
                }

            });
        }
        if (this.state.openBetsList.length < storeData.vpp.openBetsList.length) {
            gameCatgories.forEach((gameCategory) => {
                let betsOfGivenCategoryPrev = this.state.openBetsList.filter((betSelection) => betSelection.bets[0].game.gameCategory === gameCategory);
                let betsOfGivenCategoryCurrent = storeData.vpp.openBetsList.filter((betSelection) => betSelection.bets[0].game.gameCategory === gameCategory);
                if (betsOfGivenCategoryCurrent > betsOfGivenCategoryPrev && storeData.vpp.collapsedOpenBetAccordions.includes(gameCategory)) {
                    this.props.store.dispatch(collapseOpenBetAccordion(gameCategory))
                }

            });
        }
        if (nextProps && storeData) {
            this.setState({
                selectedBetSlipScreen: storeData.vpp.selectedBetSlipScreen,
                openBetsList: storeData.vpp.openBetsList,
                placedBets: storeData.vpp.placedBets,
                settledBets: storeData.vpp.settledBets,
                isUnreadBetsNotificationToggled: storeData.vpp.isUnreadBetsNotificationToggled,
                isBetSlipModalOpen: storeData.vpp.isBetSlipModalOpen,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }

        // if a specific tab is already open, mark the bet as isRead = true on local bets
        if (storeData.vpp.isBetSlipModalOpen && (storeData.vpp.selectedBetSlipScreen === PLACED_BETS || storeData.vpp.selectedBetSlipScreen === SETTLED_BETS)) {
            updateSportsBookLocalBetsReadStatus(storeData.vpp.selectedBetSlipScreen, storeData.vpp.playerUID);
        }
    }
    componentDidMount() {
        let betSlipHeight = document.getElementById("betslipModalContainer") ? document.getElementById("betslipModalContainer").clientHeight : 0;
        if(betSlipHeight > 0 ){
            this.props.store.dispatch(setBetSlipModalContainerHeight(betSlipHeight))
        }
    }
    componentDidUpdate(){
        let betSlipHeight = document.getElementById("betslipModalContainer") ? document.getElementById("betslipModalContainer").clientHeight : 0;
        if(betSlipHeight > 0 ){
            this.props.store.dispatch(setBetSlipModalContainerHeight(betSlipHeight))
        }
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();

        let content;
        let closeButton = '';

        if (this.state.isBetSlipModalOpen) {
            switch (this.state.selectedBetSlipScreen) {
                case OPEN_BETS:
                    content = <OpenBets store={this.props.store}/>;
                    break;
                case PLACED_BETS:
                    content = <PlacedBets store={this.props.store}/>;
                    break;
                case SETTLED_BETS:
                    content = <SettledBets store={this.props.store}/>;
                    break;
                default:
                    content = (<div className={style.emptyContainer}></div>);
            }
        } else {
            content = (<div className={style.emptyContainer}></div>);
        }


        let betsList = getItem(storeData.vpp.playerUID, UNREAD_BETS) || {placedBets: [], settledBets: []};
        let openBetsToAppear = this.state.openBetsList.filter(eventBet => eventBet.bets.length === 1);
        let openBetsCounterUI = this.state.openBetsList.length > 0
            ? <Counter animate={true} store={this.props.store} count={openBetsToAppear.length}
                       wrapperStyle={style.counterWrapper}/>
            : null;

//    let placedBetsToAppear = betsList.placedBets.filter((bet) => !bet.isRead);
        let placedBetsToAppear = this.state.placedBets;
        let placedBetsCounterUI = placedBetsToAppear.length > 0
            ? <Counter store={this.props.store} count={placedBetsToAppear.length} wrapperStyle={style.counterWrapper}/>
            : null;


        let settleBetsToAppear = betsList.settledBets.filter((bet) => !bet.isRead);
        let settledBetsCounterUI = settleBetsToAppear.length > 0
            ? <Counter store={this.props.store} count={settleBetsToAppear.length} wrapperStyle={style.counterWrapper}/>
            : null;

        let settledButtonStyle = `${style.headerItem} ${this.state.selectedBetSlipScreen === SETTLED_BETS ? style.selected : ''} ${this.state.isUnreadBetsNotificationToggled ? style.flashingButton : ''}`;
        if (this.props.isCloseButtonPresent) {
            closeButton = (<div id={'close_bet_slip_button'} className={style.closeButtonContainer}
                                onClick={() => this.props.store.dispatch(openCloseBetSlipModal())}>
                <div className={style.closeButtonWrap}>
                    <div className={style.closeButton} alt={'close'}></div>
                </div>
            </div>)
        }

        return (<div className={style.modalContainer} id={'betslipModalContainer'}>
            <div className={style.modalContentHeaderWrapper}>
                <div className={style.modalContentHeader}>
                    <div id={'open_bets_tab'}
                         className={`${style.headerItem} ${this.state.selectedBetSlipScreen === OPEN_BETS
                             ? style.selected
                             : ''}`} onClick={() => this._changeSelection(OPEN_BETS)}>
                        {openBetsCounterUI}
                        <div className={style.headerItemText}>{getText('SLIP', this.props.store)}</div>
                    </div>
                    <div id={'placed_bets_tab'}
                         className={`${style.headerItem} ${this.state.selectedBetSlipScreen === PLACED_BETS
                             ? style.selected
                             : ''}`} onClick={() => this._changeSelection(PLACED_BETS)}>
                        {placedBetsCounterUI}
                        <div className={style.headerItemText}>{getText('OPEN_BETS', this.props.store)}</div>
                    </div>
                    <div id={'settled_bets_tab'} className={settledButtonStyle}
                         onClick={() => this._changeSelection(SETTLED_BETS)}>
                        {settledBetsCounterUI}
                        <div className={style.headerItemText}>{getText('SETTLED_BETS', this.props.store)}</div>
                    </div>
                    {closeButton}
                </div>
            </div>
            <div className={style.modalBody}>
                {content}
            </div>
        </div>);
    }

    _changeSelection(option) {
        this.props.store.dispatch(changeBetSlipModalSelectedScreen(option));
    }

}

export default connect(mapStateToProps)(BetSlipModal);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/betSlipModal.js